import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  SHOP_BY_OFFER_NEAR_YOU,
  USING_SANDBOX_ENVIRONMENT,
  BASE_URL_FOR_ELASTIC_SEARCH
} from '../../../Constants/Config';
import { waitForElasticConnection } from '../../../hooks/checkElasticConnection.js';

const initialState = {
  loading: false,
  shopByOfferList: [],
  error: '',
  totalPages: 0,
  hasMore: true,
};

export const fetchShopByOfferLists = createAsyncThunk(
  'shopByOfferList/fetchShopByOfferLists',
  async ({ payload, signal }, { rejectWithValue, getState }) => {
   
    const isElasticConnected = await waitForElasticConnection(getState);
    // const isElasticConnected =false;
    const baseUrl = isElasticConnected
      ? BASE_URL_FOR_ELASTIC_SEARCH
      : BASE_URL_SANDBOX;
    const { shopByOfferList } = getState().shopByOfferList;
    if (shopByOfferList.length > 0 && !payload?.forceRefresh) {
      return { shopByOfferList, totalPages: getState().shopByOfferList.totalPages };
    }

    try {
      const controller = new AbortController();
      if (signal) {
        // If we get a signal from the component, use it to abort the request
        signal.addEventListener('abort', () => controller.abort());
      }

      const formData = new FormData();
      formData.append('lat', payload?.lat || '');
      formData.append('long', payload?.long || '');
      formData.append('store', payload?.store || '');
      
      const response = await axios.post(
        `${baseUrl}${SHOP_BY_OFFER_NEAR_YOU}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          signal: controller.signal,
        },
      );

      if (response.status === 200 && response.data?.data) {
        const shopByOfferList = response.data.data.filter(
          ({ flag }) => +flag === USING_SANDBOX_ENVIRONMENT,
        );
        
        return {
          shopByOfferList,
          totalPages: response.data.totalPages || 0,
        };
      }
      
      return { shopByOfferList: [], totalPages: 0 };
      
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        return rejectWithValue('Request was canceled');
      }
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const newArrivalSlice = createSlice({
  name: 'shopByOfferList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchShopByOfferLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShopByOfferLists.fulfilled, (state, action) => {
        state.loading = false;
        state.shopByOfferList = action.payload?.shopByOfferList;
        state.totalPages = action.payload?.totalPages || 0;
        state.error = '';
      })
      .addCase(fetchShopByOfferLists.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || 'Failed to fetch  Shop by Offers Near You';
        state.hasMore = false;
      });
  },
});

export default newArrivalSlice.reducer;
